import React from 'react';
import {
  MdRocketLaunch, MdAssignment, MdReceiptLong, MdEventBusy, MdCalendarViewWeek,
  MdNotificationsActive, MdEditNote, MdWorkspacePremium, MdAccountBalanceWallet,
  MdInsights, MdUpgrade, MdAdminPanelSettings, MdForum,
} from 'react-icons/md';
import './roadmap.css';

/**
 * التحديثات القادمة — what is planned next, for the manager. A plain
 * list: move an item out of here (and into «ما الجديد») once it is live.
 */
const GROUPS = [
  {
    title: 'للأهالي والطلاب',
    items: [
      {
        icon: MdAccountBalanceWallet, tone: 'emerald', title: 'الدفع عبر شام كاش', top: true,
        text: 'يرى ولي الأمر رقم حساب المدرسة والمبلغ المطلوب، يدفع من شام كاش ثم يرفع صورة الوصل. تصل الدفعة للمكتب للتأكيد، وعند الموافقة تُسجَّل تلقائياً ويصل للأهل إيصالها.',
      },
      {
        icon: MdAssignment, tone: 'violet', title: 'الواجبات والوظائف',
        text: 'المعلم ينشر الوظيفة لصفّه، والطالب وأهله يرونها في البوابة والتطبيق.',
      },
      {
        icon: MdEventBusy, tone: 'gold', title: 'تبرير الغياب من الأهل',
        text: 'ولي الأمر يرسل سبب الغياب من التطبيق، والموجه يوافق عليه أو يرفضه.',
      },
      {
        icon: MdReceiptLong, tone: 'sky', title: 'إيصال الدفع وكشف الحساب',
        text: 'تنزيل إيصال كل دفعة وكشف حساب كامل من بوابة الأهل.',
      },
      {
        icon: MdCalendarViewWeek, tone: 'teal', title: 'البرنامج الأسبوعي',
        text: 'جدول الحصص لكل شعبة، يراه الطالب والمعلم.',
      },
      {
        icon: MdNotificationsActive, tone: 'rose', title: 'تذكير تلقائي بالأقساط',
        text: 'إشعار أو رسالة تصل كل شهر لمن عليه قسط متأخر.',
      },
      {
        icon: MdEditNote, tone: 'sky', title: 'تحديث بيانات التواصل',
        text: 'ولي الأمر يعدّل رقم هاتفه وعنوانه، ويصل التعديل للمكتب ليوافق عليه.',
      },
      {
        icon: MdWorkspacePremium, tone: 'gold', title: 'الجلاء المدرسي',
        text: 'جلاء رسمي آخر كل فصل، جاهز للطباعة وللتنزيل من بوابة الأهل.',
      },
    ],
  },
  {
    title: 'للإدارة',
    items: [
      {
        icon: MdInsights, tone: 'violet', title: 'تقارير المدير',
        text: 'نسبة الحضور لكل صف، معدلات العلامات، والمدخول الشهري مقابل المتوقع — مع تصدير Excel.',
      },
      {
        icon: MdUpgrade, tone: 'emerald', title: 'ترحيل آخر السنة',
        text: 'نقل كل الطلاب إلى الصف الأعلى بخطوة واحدة، مع تحديد الراسبين.',
      },
      {
        icon: MdAdminPanelSettings, tone: 'teal', title: 'صلاحيات أدق للكادر',
        text: 'تحديد ما يراه كل موظف وما يعدّله، مثل عرض الأقساط دون تعديلها.',
      },
      {
        icon: MdForum, tone: 'rose', title: 'مراسلة بين الأهل والمعلم',
        text: 'محادثة بسيطة داخل النظام بدل التواصل خارج المدرسة.',
      },
    ],
  },
];

export default function Roadmap() {
  return (
    <div className="rm-page">
      <section className="rm-hero">
        <MdRocketLaunch className="rm-hero-icon" />
        <div>
          <h1>التحديثات القادمة</h1>
          <p>ما نعمل عليه لاحقاً في بوابة مشكاة.</p>
        </div>
      </section>

      {GROUPS.map((g) => (
        <section key={g.title} className="rm-group">
          <h2>{g.title}</h2>
          <div className="rm-grid">
            {g.items.map((it) => (
              <article key={it.title} className={`rm-card rm-${it.tone}${it.top ? ' rm-top' : ''}`}>
                <span className="rm-icon"><it.icon /></span>
                <div className="rm-body">
                  <h3>
                    {it.title}
                    {it.top && <span className="rm-badge">قريباً</span>}
                  </h3>
                  <p>{it.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
